import React, { useEffect, useState, Children, isValidElement, cloneElement } from "react";
import AuxHeader from "./AuxHeader";
import AuxFooter from "./AuxFooter";

const decodeToken = (rawToken) => {
  if (!rawToken) return null;
  const token = rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
  const segments = token.split(".");
  if (segments.length < 2) return null;

  try {
    const base64 = segments[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);
    const json = atob(padded);
    const decoded = decodeURIComponent(
      json
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );
    return JSON.parse(decoded);
  } catch (error) {
    console.error("Failed to decode JWT payload:", error);
    return null;
  }
};

const ProtectedLayout = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const rawToken = localStorage.getItem("token");
    const payload = decodeToken(rawToken);

    if (payload) {
      const normalizedType = (payload.userType || payload.UserType || "Student").toLowerCase();
      const capitalizedType = normalizedType.charAt(0).toUpperCase() + normalizedType.slice(1);

      const enrichedUser = {
        ...payload,
        name: payload.DisplayName || payload.name || payload.Name || "User",
        FirstName: payload.FirstName || payload.firstName || payload.given_name || "",
        LastName: payload.LastName || payload.lastName || payload.family_name || payload.surname || "",
        DisplayName: payload.DisplayName || payload.name || "",
        Email:
          payload.Email ||
          payload.email ||
          payload.mail ||
          payload.userPrincipalName ||
          payload.upn ||
          payload.preferred_username ||
          "",
        Department: payload.Department || payload.department || "",
        Honorific: payload.Honorific || payload.title || "",
        userType: capitalizedType,
        normalizedUserType: normalizedType,
      };

      localStorage.setItem("userType", capitalizedType);
      localStorage.setItem("userTypeNormalized", normalizedType);
      setUser(enrichedUser);
    } else {
      setUser({ name: "User", userType: "Student", normalizedUserType: "student" });
    }
  }, []);

  if (!user) {
    return <div>Loading...</div>;
  }

  const enhancedChildren = Children.map(children, (child) =>
    isValidElement(child) ? cloneElement(child, { userData: user }) : child
  );

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <AuxHeader user={user} />
      <main
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {enhancedChildren}
      </main>
      <AuxFooter />
    </div>
  );
};

export default ProtectedLayout;
